import { Button, Popconfirm, Space, Table } from "antd"
import { PlanPermissionModal } from "./PlanPermissionModal"
import { useRequest } from "ahooks"
import { deletePlanPermission, getPlanPermissions } from "@/services/plan-permission/plan-permission.service"

export const PlanPermissions = () => {

  const {data: planPermissions, run: getList} = useRequest(getPlanPermissions)

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Actions',
      render: (_, record) => (
        <Space>
          <Button size="small"
          onClick={() => {
            PlanPermissionModal.show({
              planPermission: record,
              onSuccess: async () => {
                getList()
              }
            })
          }}
          >Edit</Button>
          <Popconfirm
            title="Delete the Permission"
            description="Are you sure to delete this Permission?"
            onConfirm={async () => {
              await deletePlanPermission(record.code)
              getList()
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type='link' danger size='small'>Delete</Button>
          </Popconfirm>
        </Space>
      )
    },
  ]

  return (
    <div>
      <div className="flex-end mb-2">
        <Button
          type="primary"
          onClick={() => {
            PlanPermissionModal.show({
              onSuccess: async () => {
                getList()
              }
            })
          }}
        >Add Permission</Button>
      </div>
      <Table columns={columns} dataSource={planPermissions || []} size="small" bordered/>
    </div>
  )
}